<footer class="app-footer" id="app-footer">
  <span class="bs-float-right"><span class="bs-text-primary">{{appName}}</span> | Powered by Shift Digital - &copy; {{currentYear}} Shift Digital</span>
</footer>
